module.exports = __webpack_public_path__ + "img/20200620_094405.0ca09eaf.jpg";